import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const toolbarOptions: any[] = [
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{'script': 'sub'}, {'script': 'super'}],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'size': ['small', false, 'large', 'huge']}],
  [{'color': []}, {'background': []}],
  ['clean'],
  ['link', 'image'],
];
interface ToolbarModuleType {
  toolbar: any[];
}
declare module 'react-quill' {
  interface Quill {
    getModule(name: string): ToolbarModuleType | null;
  }
}
const RichTextEditor: React.FC<{
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled = false }) => {
  const modules: ToolbarModuleType = {
    toolbar: toolbarOptions,
  };
  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules} // Pass the toolbar options to modules prop
      style={{ height: '10rem' }}
      readOnly={disabled} // Set readOnly prop based on disabled value
    />
  );
};
export default RichTextEditor;